
<app-header></app-header>
<section style="margin-top:100px">

    <h2 class="center">Task Center</h2>
        </section>

        <div class="nav-container">
                <ul class="nav-list">
                    <li class="nav-item">
                        <a href="#" class="nav-link active">
                            <i class="fas fa-globe"></i> <!-- All Icon -->
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link">
                            <i class="fab fa-youtube"></i> <!-- YouTube Icon -->
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link">
                            <i class="fab fa-telegram-plane"></i> <!-- Telegram Icon -->
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link">
                            <i class="fab fa-twitter"></i> <!-- Twitter Icon -->
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link">
                            <i class="fab fa-facebook-f"></i> <!-- Facebook Icon -->
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link">
                            <i class="fab fa-instagram"></i> <!-- Instagram Icon -->
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link">
                            <i class="fab fa-linkedin-in"></i> <!-- LinkedIn Icon -->
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link">
                            <i class="fas fa-share-alt"></i> <!-- Generic Social Media Icon -->
                        </a>
                    </li>
                </ul>
                
        
                <div class="dropdown">
                    <button class="dropdown-btn">Completed</button>
                    <div class="dropdown-menu">
                        <a href="#" class="dropdown-item">Upcoming</a>
                        <a href="#" class="dropdown-item">Join & Bid</a>
                        <a href="#" class="dropdown-item">Achieved</a>
                    </div>
                </div>
            </div>
            <div class="tab-pane active">
                <div class="container">
                    <div class="image-grid">
                        <img *ngFor="let image of imageUrls" [src]="image" alt="Crypto Image">
                    </div>
                </div>
            </div>
      
  <section style="margin-top:320px">
    <app-footer></app-footer>
</section>
